export { useGrowthBookConfig } from './useGrowthBookConfig';
